export const HELP_TEXT =
  'This quote is based on the excess selected. Select a higher excess to reduce your premium further (subject to minimum premiums).';

export const LINK_TEXT = 'How excess works';

export enum ExcessName {
  Standard = 'Standard',
  Nominated = 'Nominated',
  DamageCausedByTenants = 'DamageCausedByTenants',
  TenantsRentDefault = 'TenantsRentDefault',
  LossOfRent = 'LossOfRent',
}

type ExcessDetails = {
  excessTableRowTitle: string;
  heading: string;
  summaryLabel?: string;
  amount?: number;
};

export const excessDetails: Record<ExcessName, ExcessDetails> = {
  [ExcessName.Standard]: {
    heading: 'Standard excess',
    excessTableRowTitle: 'Standard excess',
  },
  [ExcessName.Nominated]: {
    heading: 'Nominated excess',
    excessTableRowTitle: 'Nominated excess',
  },
  [ExcessName.DamageCausedByTenants]: {
    summaryLabel: 'Damage caused by tenants',
    heading: 'Damage caused by tenants excess',
    excessTableRowTitle: 'Damage caused by tenants excess (if applicable)',
    amount: 300,
  },
  [ExcessName.LossOfRent]: {
    summaryLabel: 'Loss of rent',
    heading: 'Loss of rent excess',
    excessTableRowTitle: 'Loss of rent excess (if applicable)',
    amount: 300,
  },
  [ExcessName.TenantsRentDefault]: {
    summaryLabel: 'Tenants rent default',
    heading: 'Tenants rent default excess',
    excessTableRowTitle: 'Tenants rent default excess (if applicable)',
    amount: 300,
  },
};
